import { createAttendee } from './utils-module.js';
import {
  isAssignedAttendeeUid,
  isNeedToShowPrivacy,
  redirectToHome,
  initRegForm,
  saveRegData,
  getErrorRegFallBecauseOfAttendeeNull,
  initPrivacyPolicyLink,
  prepareRegPage,
} from './registration/index.js';
import { assertPageParams, validationVariants, pageParams, fetchData } from './page.js';
import { setBackground, setLogo } from './customizePage/registration.js';
import { appendQueryParams, redirectToPage } from './page-routes.js';

const { isSetUpEventName } = validationVariants;
const { eventName } = pageParams;

const form = initRegForm();

async function init() {
  prepareRegPage();
  assertPageParams([isSetUpEventName]);

  if (isAssignedAttendeeUid()) {
    redirectToHome();
  }

  initPrivacyPolicyLink();

  const event = await fetchData.event();

  const { opts } = event;

  setLogo(opts.webappCustomLogoSrc);
  setBackground(opts.webappCustomBackgroundSrc);

  if (opts.webappIsEnabledSMS) {
    form.enablePhoneNumber(opts.webappSMSAgreement);
  }

  if (isNeedToShowPrivacy(opts)) {
    form.enableAgreePrivacy();
  }

  form.onSubmit(async ({ name, email, phoneNumber }) => {
    const { result: attendeeUid } = await createAttendee({
      eventCode: eventName(),
      name,
      email,
      phoneNumber,
    });
    if (!attendeeUid) {
      alert(getErrorRegFallBecauseOfAttendeeNull({ canBeEmailConfirmationProblem: true }));
      return;
    }
    saveRegData({ attendeeUid });
    redirectToPage.index({ rawSearch: appendQueryParams(window.location.search, { uId: attendeeUid }) });
  });
}

document.addEventListener('DOMContentLoaded', init);
